import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchStoresByService } from '@entities/Shop/module/services/fetchStoresByService';
import { StoresByServiceSchema, StoresByServiceType } from '@entities/Shop/module/types/storesByServiceSchema';

const initialState: StoresByServiceSchema = {
  storesByService: [],
  isDistance: false,
  isLoaded: false,
};

export const storesByServiceSlice = createSlice({
  name: 'storesByService',
  initialState,
  reducers: {
    setDistance: (state, action: PayloadAction<StoresByServiceType[]>) => {
      state.storesByService = action.payload;
      state.isDistance = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.storesByService,
      };
    });
    builder.addCase(fetchStoresByService.pending, state => {
      state.isLoaded = false;
    });
    builder.addCase(fetchStoresByService.fulfilled, (state, action) => {
      if (action.payload) {
        state.storesByService = action.payload.shops;
      }
      state.isLoaded = true;
    });
    builder.addCase(fetchStoresByService.rejected, state => {
      state.isLoaded = true;
    });
  },
});

export const { actions: storesByServiceActions } = storesByServiceSlice;
